import Notices from "./Notices";
import Modal from "./Modal";
import ProductList from "./ProductList";

export default class AddToCart {
	constructor() {
		this.jsVariableProductForm = document.querySelectorAll(".jsVariableProductForm");
		this.jsProductModalWr = document.querySelector(".jsProductModalWr");
		this.jsModalAddToCart = document.querySelector(".jsModalAddToCart");
		this.jsHeaderCartIcon = document.querySelector(".jsHeaderCartIcon");
		this.jsHeaderCartCount = document.querySelectorAll(".jsHeaderCartCount");
		this.jsMinicartOverlay = document.querySelector(".jsMinicartOverlay");
		this.jsMinicart = document.querySelector(".jsMinicart");
		this.jsMinicartClose = document.querySelector(".jsMinicartClose");
		this.jsMinicartContent = document.querySelector(".jsMinicartContent");
		this.notices = new Notices();

		this.events();
	}

	events() {
		if (this.jsVariableProductForm) {
			this.jsVariableProductForm.forEach((form) => {
				form.addEventListener("submit", this.addToCart.bind(this));
			});
		}

		if (this.jsHeaderCartIcon && this.jsMinicart && this.jsMinicartOverlay) {
			this.jsHeaderCartIcon.addEventListener("click", this.showMinicart.bind(this));
		}

		if (this.jsMinicartOverlay) {
			this.jsMinicartOverlay.addEventListener("click", (event) => {
				if (event.target === this.jsMinicartOverlay) {
					this.closeMinicart();
				}
			});
		}

		if (this.jsMinicartClose) {
			this.jsMinicartClose.addEventListener("click", this.closeMinicart.bind(this));
		}
	}

	showMinicart() {
		this.jsMinicart.classList.add("is-open");
		this.jsMinicartOverlay.classList.add("is-open");
	}

	closeMinicart() {
		this.jsMinicart.classList.remove("is-open");
		this.jsMinicartOverlay.classList.remove("is-open");
	}

	addToCart(event) {
		event.preventDefault();
		if (event.target.querySelector(".jsBaseVariationAddToCartBtn").classList.contains("disabled")) {
			document.querySelector(".jsBaseVariationAddToCartBtn").click();
			return;
		}

		const myFormData = new FormData(event.target);
		myFormData.append("security", window.global.security);

		event.target.querySelector(".jsBaseVariationAddToCartBtn").classList.add("single_add_to_cart_button--loading");
		event.target.querySelector(".jsBaseVariationAddToCartBtn").disabled = true;

		fetch(window.global.ajax_url + "?action=addToCart", {
			method: "POST",
			mode: "cors",
			cache: "no-cache",
			credentials: "same-origin",
			redirect: "follow",
			referrerPolicy: "no-referrer",
			body: myFormData,
		})
			.then((resp) => resp.json())
			.then((res) => {
				this.notices.addNotices(res.data.notices, 10000);
				const addToCartButton = event.target.querySelector(".jsBaseVariationAddToCartBtn");

				addToCartButton.classList.remove("single_add_to_cart_button--loading");
				addToCartButton.disabled = false;

				if (!res.success) {
					return;
				}
				const modalContent = document.getElementById(addToCartButton.dataset.modal);
				new Modal().displayModal(modalContent);

				this.jsProductModalWr.innerHTML = res.data.content;

				this.jsMinicartContent.innerHTML = res.data.cart_content;

				this.jsHeaderCartCount.forEach((count) => (count.innerHTML = res.data.cart_count));

				let sliderProductListPopup = document.querySelector(".jsProductModalWr .jsProductListSlider");

				new ProductList().initializeProductListSlider(sliderProductListPopup);
			});
	}
}
